import { MethodInfoBlock, methodInfoStyles } from '@/core/components/MethodInfoBlock'
import { TypeLink } from '@/core/components/TypeLink'
import type { TypeUsage } from '@/core/types/library.type'

interface MethodReturnsProps {
  returns?: string
  returnTypeUsage?: TypeUsage
}

export function MethodReturns({ returns, returnTypeUsage }: MethodReturnsProps) {
  return (
    <MethodInfoBlock title="Returns">
      <TypeLink typeName={returns} typeUsage={returnTypeUsage} className={methodInfoStyles.valueType} />
    </MethodInfoBlock>
  )
}
